module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /usr/local/lib/~/cooking-cli/~/stream-browserify/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 188
// module chunks = 1